export enum EnumTpStatusSessao {
    Aberta = 0,
    Fechada = 1,
    Conferida = 2
}